<div *ngIf="active" class="tab-content">
  <ng-content></ng-content>
</div>